module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/ipfs/js-ipfs",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "https://camo.githubusercontent.com/44d46e125f11fe293dde1e6c92760b1ad6253132/68747470733a2f2f697066732e696f2f697066732f516d566b37737272776168584c4e6d634459767955454a7074796f78706e646e52613537594a31314c346a5632362f697066732e6a732e706e67"
    }
  })])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "5"
    },
    on: {
      "click": _vm.openNodeInfo
    }
  }, [_c('el-button', {
    attrs: {
      "plain": true,
      "size": "small",
      "type": "info"
    }
  }, [_vm._v("info")])], 1), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "5"
    }
  }, [_vm._v(_vm._s(_vm.status))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "6"
    }
  }, [_vm._v("Connected Peers: " + _vm._s(_vm.node.peers.length))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "7"
    }
  }), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "8"
    }
  }, [(_vm.status === 'stopped') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.startNode
    }
  }, [_vm._v("Start")]) : _vm._e(), _vm._v(" "), (_vm.status != 'stopped') ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.stopNode
    }
  }, [_vm._v("Stop")]) : _vm._e(), _vm._v(" "), (_vm.status === 'starting') ? _c('el-button', {
    attrs: {
      "type": "simple",
      "loading": true,
      "size": "small"
    }
  }, [_vm._v("Starting")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dabebb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopNav.vue
// module id = 911
// module chunks = 1